import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const defaultConversion = {
  whatsapp_number: '34694214849',
  whatsapp_message: 'Hola, me interesa MANDO para mi empresa de reformas',
  whatsapp_cta_text: 'Hablemos por WhatsApp',
  whatsapp_enabled: true,
};

const WhatsAppButton = () => {
  const [conversion, setConversion] = useState(defaultConversion);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [showTooltipAuto, setShowTooltipAuto] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/public/conversion-settings`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data) setConversion(prev => ({ ...prev, ...data })); })
      .catch(() => {});
  }, []);

  // Show tooltip automatically after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTooltipAuto(true);
    }, 5000);
    const hideTimer = setTimeout(() => {
      setShowTooltipAuto(false);
    }, 12000);
    return () => { clearTimeout(timer); clearTimeout(hideTimer); };
  }, []);

  if (!conversion.whatsapp_enabled) return null;

  const waUrl = `https://wa.me/${conversion.whatsapp_number}?text=${encodeURIComponent(conversion.whatsapp_message)}`;
  const visible = isTooltipVisible || showTooltipAuto;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-2 pointer-events-none'
        }`}
      >
        <div className="relative bg-white rounded-2xl shadow-xl px-4 py-3 max-w-xs flex items-start gap-2">
          <button
            onClick={() => setShowTooltipAuto(false)}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
            aria-label="Cerrar"
          >
            <X size={14} />
          </button>
          <div className="w-8 h-8 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <MessageCircle className="w-4 h-4 text-white" />
          </div>
          <div>
            <p className="text-gray-800 text-sm font-semibold">¿Tienes dudas sobre MANDO?</p>
            <p className="text-gray-500 text-xs mt-0.5">{conversion.whatsapp_cta_text}</p>
          </div>
        </div>
        {/* Arrow */}
        <div className="flex justify-end pr-6">
          <div className="w-3 h-3 bg-white rotate-45 -mt-1.5 shadow-sm" />
        </div>
      </div>

      {/* WhatsApp Button */}
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={() => setIsTooltipVisible(false)}
        className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all duration-300 hover:shadow-[#25D366]/40 hover:shadow-xl"
        aria-label="Contactar por WhatsApp"
        data-testid="whatsapp-float-btn"
      >
        <svg viewBox="0 0 24 24" className="w-7 h-7 text-white fill-current">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
        {/* Pulse ring */}
        <span className="absolute w-14 h-14 rounded-full bg-[#25D366]/30 animate-ping" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
